import Vue from 'vue';
import Vuex from 'vuex';
// Vuex 模块
// import router from './modules/router';
import common from './common';
import plugins from './modules/plugin';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    plugins,
    // router,
  },

  ...common,
});
